import { createNotification } from "../components/Notifications/Notifications";
import {
    SET_GROUPS_DO_VD_LIST,
    SET_GROUPS_DO_VD_LOADING,
    SET_GROUPS_DO_VD_ITEM,
    SET_GROUPS_DO_VD_ITEM_LOADING,
    SET_GROUPS_DO_VD_COURSES,
    SET_GROUPS_DO_VD_STUDENTS,
    SET_GROUPS_DO_VD_STUDENTS_LOADING
} from "./types";
import { api } from "../App";

// type: 0 = ДО (xp_group), 1 = ВД (out_group)

export const getGroupsList = (type, params = {}) => async (dispatch, getState) => {
    dispatch({ type: SET_GROUPS_DO_VD_LOADING, payload: true });
    try {
        // Фильтруем пустые параметры
        const filteredParams = { type };
        Object.keys(params).forEach(key => {
            if (params[key] !== '' && params[key] !== undefined && params[key] !== null) {
                filteredParams[key] = params[key];
            }
        });
        const urlParams = new URLSearchParams(filteredParams).toString();
        const { data } = await api.get(`/group_mode?${urlParams}`);
        dispatch({ type: SET_GROUPS_DO_VD_LIST, payload: data });
    } catch (error) {
        dispatch({ type: SET_GROUPS_DO_VD_LIST, payload: [] });
        createNotification('error', error.response?.data?.error || 'Ошибка загрузки списка');
    } finally {
        dispatch({ type: SET_GROUPS_DO_VD_LOADING, payload: false });
    }
};

export const getGroupItem = (id, type) => async (dispatch, getState) => {
    dispatch({ type: SET_GROUPS_DO_VD_ITEM_LOADING, payload: true });
    try {
        const { data } = await api.get(`/xp_group/${id}?type=${type}`);
        dispatch({ type: SET_GROUPS_DO_VD_ITEM, payload: data });
    } catch (error) {
        dispatch({ type: SET_GROUPS_DO_VD_ITEM, payload: {} });
    } finally {
        dispatch({ type: SET_GROUPS_DO_VD_ITEM_LOADING, payload: false });
    }
};

export const createGroup = (data, type) => async (dispatch, getState) => {
    try {
        const endpoint = type === 0 ? 'xp_group' : 'out_group';
        const { data: result } = await api.post(`/${endpoint}`, data);
        return result.xp_key || result.id || result;
    } catch (error) {
        createNotification('error', error.response?.data?.error || 'Ошибка создания');
        return null;
    }
};

export const updateGroup = (id, data, type) => async (dispatch, getState) => {
    try {
        const endpoint = type === 0 ? 'xp_group' : 'out_group';
        await api.put(`/${endpoint}/${id}`, data);
        return id;
    } catch (error) {
        createNotification('error', error.response?.data?.error || 'Ошибка обновления');
        return null;
    }
};

export const deleteGroup = (id, type, params) => async (dispatch, getState) => {
    dispatch({ type: SET_GROUPS_DO_VD_LOADING, payload: true });
    try {
        const endpoint = type === 0 ? 'xp_group' : 'out_group';
        await api.delete(`/${endpoint}/${id}`);
        createNotification('success', 'Группа удалена');
        await dispatch(getGroupsList(type, params));
    } catch (error) {
        createNotification('error', error.response?.data?.error || 'Ошибка удаления');
    } finally {
        dispatch({ type: SET_GROUPS_DO_VD_LOADING, payload: false });
    }
};

export const getCourses = (type) => async (dispatch, getState) => {
    try {
        const endpoint = type === 0 ? 'xp_courses' : 'out_courses';
        const { data } = await api.get(`/${endpoint}`);
        dispatch({ type: SET_GROUPS_DO_VD_COURSES, payload: data });
    } catch (error) {
    }
};

export const addTermType = (data, type) => async (dispatch, getState) => {
    try {
        const endpoint = type === 0 ? 'xp_group_term_types' : 'out_group_term_types';
        const { data: result } = await api.post(`/${endpoint}`, data);
        createNotification('success', 'Тип уч. периода добавлен');
        return result;
    } catch (error) {
        createNotification('error', error.response?.data?.error || 'Ошибка добавления');
        return null;
    }
};

export const updateTermType = (id, data, type) => async (dispatch, getState) => {
    try {
        const endpoint = type === 0 ? 'xp_group_term_types' : 'out_group_term_types';
        const { data: result } = await api.put(`/${endpoint}/${id}`, data);
        createNotification('success', 'Тип уч. периода обновлён');
        return result;
    } catch (error) {
        createNotification('error', error.response?.data?.error || 'Ошибка обновления');
        return null;
    }
};

export const deleteTermType = (id, type) => async (dispatch, getState) => {
    try {
        const endpoint = type === 0 ? 'xp_group_term_types' : 'out_group_term_types';
        await api.delete(`/${endpoint}/${id}`);
        createNotification('success', 'Тип уч. периода удалён');
        return true;
    } catch (error) {
        createNotification('error', error.response?.data?.error || 'Ошибка удаления');
        return false;
    }
};

export const addStudentsToGroup = (groupId, data, type) => async (dispatch, getState) => {
    try {
        const endpoint = type === 0 ? 'xp_group_structure' : 'out_group_structure';
        const { data: result } = await api.post(`/${endpoint}/${groupId}`, data);
        createNotification('success', 'Учащиеся зачислены');
        return result;
    } catch (error) {
        createNotification('error', error.response?.data?.error || 'Ошибка зачисления');
        return null;
    }
};

export const transferStudents = (data, type) => async (dispatch, getState) => {
    try {
        const endpoint = type === 0 ? 'xp_group_transfer' : 'out_group_transfer';
        const { data: result } = await api.post(`/${endpoint}`, data);
        createNotification('success', 'Перевод выполнен');
        return result;
    } catch (error) {
        createNotification('error', error.response?.data?.error || 'Ошибка перевода');
        return null;
    }
};

export const getStudentsForEnroll = (params = {}) => async (dispatch, getState) => {
    dispatch({ type: SET_GROUPS_DO_VD_STUDENTS_LOADING, payload: true });
    try {
        const urlParams = new URLSearchParams(params).toString();
        const { data } = await api.get(`/students?${urlParams}`);
        const resultForSelect = data?.map((item) => ({
                                                        mid: item.mid,
                                                        fio: item.fio,
                                                        school_class: item.school_class,
                                                        enrollment_date: item.enrollment_date
                                                        }));
        dispatch({ type: SET_GROUPS_DO_VD_STUDENTS, payload: resultForSelect });
    } catch (error) {
        dispatch({ type: SET_GROUPS_DO_VD_STUDENTS, payload: [] });
    } finally {
        dispatch({ type: SET_GROUPS_DO_VD_STUDENTS_LOADING, payload: false });
    }
};

export const clearGroupItem = () => (dispatch) => {
    dispatch({ type: SET_GROUPS_DO_VD_ITEM, payload: {} });
};
